"use client";

/**
 * Hero carousel rendered in the initial HTML so the first slide can
 * participate in LCP without waiting for client-side hydration.
 */

import { useRef } from "react";
import {
  Carousel,
  CarouselContent,
  CarouselItem,
} from "@/components/ui/carousel";
import Autoplay from "embla-carousel-autoplay";
import GcsImage from "@/components/common/GcsImage";
import { carouselImages } from "@/lib/carouselData";

export default function HeroCarousel() {
  const plugin = useRef(Autoplay({ delay: 8000, stopOnInteraction: false }));

  return (
    <Carousel
      opts={{
        loop: true,
      }}
      plugins={[plugin.current]}
      className="w-full h-full"
      onMouseEnter={() => plugin.current.stop()}
      onMouseLeave={() => plugin.current.play()}
    >
      <CarouselContent>
        {carouselImages.map((image, index) => (
          <CarouselItem key={index}>
            <div className="relative w-full aspect-square xl:aspect-auto xl:h-[600px] min-h-[400px] md:min-h-[500px] xl:min-h-[600px]">
              <GcsImage
                path={image.src}
                alt={image.alt}
                className={`w-full h-full object-cover ${
                  image.objectPositionClass ?? "object-top"
                }`}
                priority={index === 0}
              />
              {/* Savings Banner Overlay - unique for each photo - Fixed height to prevent CLS */}
              <div className="absolute bottom-6 left-6 right-6 bg-[#ffe9b4] text-[#090739] rounded-lg shadow-2xl px-4 py-3 z-10 h-[70px] md:h-[80px] flex items-center">
                <div className="text-center w-full">
                  <div className="text-sm md:text-base font-medium line-clamp-2">
                    {image.name} saved{" "}
                    <span className="text-3xl md:text-4xl font-bold text-[#209FBD]">
                      {image.amount}
                    </span>{" "}
                    {image.description}
                  </div>
                </div>
              </div>
            </div>
          </CarouselItem>
        ))}
      </CarouselContent>
    </Carousel>
  );
}
